// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const durations = {
    veryLong: 1,
    long: 0.6,
    medium: 0.35,
    short: 0.25,
    veryShort: 0.15,
};
module.exports = durations;
//# sourceMappingURL=durations.js.map